var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Switch, useMediaQuery, useTheme } from '@mui/material';
import { Add01Icon, Edit02Icon } from 'hugeicons-react';
import { Trash } from 'iconsax-reactjs';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useMemo, useRef, useState } from 'react';
import { AppConsts } from '../../../../application/common/constants/app-consts';
import { RoleCategories } from '../../../../application/common/constants/role-categories';
import { getFilteredStringOperators } from '../../../../application/common/helpers/grid-filter-operators';
import { useDeleteSpecialityMutation, useGetPaginatedSpecialitiesQuery, useUpdateSpecialityStatusMutation } from '../../../../application/features/specialities/speciality-api';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import PageHeaderButton from '../../../components/PageHeaderButton';
import ProtectedElement from '../../../components/ProtectedElement';
import { Permissions } from '../../../permissions';
import AddSpecialty from './add-specialty';
import ConfirmationDialog from './confirmation-dialog';
import DeleteSpecialtyDialog from './delete-specialty-dialog';
import EditSpecialty from './edit-specialty';
import { TechnicianSpecialtiesCards } from './technician-specialties-card';
import TechnicianSpecialtiesDatagrid from './technician-specialties-datagrid';
var TechnicianSpecialties = function () {
    var _a;
    var theme = useTheme();
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var _c = __read(useState({
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined
    }), 2), specialityFilters = _c[0], setSpecialityFilters = _c[1];
    var _d = __read(useState({
        items: []
    }), 2), filterModel = _d[0], setFilterModel = _d[1];
    var _e = __read(useState(false), 2), isAddDialogOpen = _e[0], setIsAddDialogOpen = _e[1];
    var _f = __read(useState(false), 2), isEditDialogOpen = _f[0], setIsEditDialogOpen = _f[1];
    var _g = __read(useState(false), 2), isDeleteDialogOpen = _g[0], setIsDeleteDialogOpen = _g[1];
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var _h = __read(useState(null), 2), editingSpeciality = _h[0], setEditingSpeciality = _h[1];
    var _j = __read(useState(null), 2), specialityStatus = _j[0], setSpecialityStatus = _j[1];
    var _k = __read(useState(null), 2), deletingSpecialty = _k[0], setDeletingSpecialty = _k[1];
    var _l = __read(useState(false), 2), isConfirmationDialogOpen = _l[0], setIsConfirmationDialogOpen = _l[1];
    var _m = __read(useState(''), 2), confirmationDialogContent = _m[0], setConfirmationDialogContent = _m[1];
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var _o = useGetPaginatedSpecialitiesQuery(specialityFilters, {
        refetchOnMountOrArgChange: true
    }), data = _o.data, isFetching = _o.isFetching;
    var _p = (data !== null && data !== void 0 ? data : {}).items, specialities = _p === void 0 ? [] : _p;
    var _q = __read(useUpdateSpecialityStatusMutation(), 2), triggerUpdateStatus = _q[0], _r = _q[1], isUpdateStatusLoading = _r.isLoading, isUpdateStatusSuccess = _r.isSuccess;
    var _s = __read(useDeleteSpecialityMutation(), 2), triggerDelete = _s[0], _t = _s[1], isDeleteLoading = _t.isLoading, isDeleteSuccess = _t.isSuccess;
    useEffect(function () {
        if (isUpdateStatusSuccess) {
            enqueueSnackbar(tWithField((specialityStatus === null || specialityStatus === void 0 ? void 0 : specialityStatus.isActive) ? 'toolTips.activateSuccess' : 'toolTips.deactivateSuccess', 'common.speciality'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUpdateStatusSuccess]);
    useEffect(function () {
        if (isDeleteSuccess) {
            enqueueSnackbar(tWithField('toolTips.deleteSuccess', 'common.speciality'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDeleteSuccess]);
    var handlePaginationModelChange = function (model) {
        setSpecialityFilters(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var handleSortModelChange = function (model) {
        setSpecialityFilters(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setSpecialityFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setSpecialityFilters(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setSpecialityFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var rowCountRef = useRef((_a = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _a !== void 0 ? _a : 0);
    var rowCount = useMemo(function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) !== undefined) {
            rowCountRef.current = data === null || data === void 0 ? void 0 : data.totalCount;
        }
        return rowCountRef.current;
    }, [data === null || data === void 0 ? void 0 : data.totalCount]);
    var generateRoleColumns = function () {
        var keys = ['name'];
        var headers = {
            name: translate('common.name')
        };
        var baseColumns = keys.map(function (key) { return ({
            field: key,
            headerName: headers[key] || key.charAt(0).toUpperCase() + key.slice(1),
            type: 'string',
            flex: isXs ? undefined : isscreen600900 ? 2 : isSm ? 2 : 2,
            minWidth: isXs ? 150 : isscreen600900 ? undefined : undefined,
            width: isXs ? 250 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators()
        }); });
        var additionalColumns = [];
        if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin) {
            additionalColumns.push({
                field: 'companyName',
                headerName: translate('common.company'),
                type: 'string',
                flex: isXs ? undefined : isscreen600900 ? 2 : isSm ? 2 : 2,
                minWidth: isXs ? 150 : isscreen600900 ? undefined : undefined,
                width: isXs ? 250 : isscreen600900 ? 200 : undefined,
                filterOperators: getFilteredStringOperators()
            });
        }
        additionalColumns.push({
            field: 'isActive',
            filterable: false,
            headerName: translate('common.active'),
            flex: isXs ? undefined : isscreen600900 ? 1 : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? undefined : undefined,
            width: isXs ? 250 : isscreen600900 ? undefined : undefined,
            renderCell: function (params) { return (_jsx(ProtectedElement, { permissions: [Permissions.Settings.Update], children: _jsx(Switch, { disabled: isUpdateStatusLoading, checked: params.row.isActive, onChange: function () { return handleSwitchChange(params.row); } }) })); }
        }, {
            field: 'actions',
            headerName: translate('common.actions'),
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: function (params) { return (_jsxs(Box, { display: 'flex', alignItems: 'center', gap: 1, mt: 1, children: [_jsx(ProtectedElement, { permissions: [Permissions.Settings.Update], children: _jsx(IconButton, { size: 'small', onClick: function () { return handleEditDialogOpen(params.row); }, children: _jsx(Edit02Icon, {}) }) }), _jsx(ProtectedElement, { permissions: [Permissions.Settings.Delete], children: _jsx(IconButton, { size: 'small', color: 'error', disabled: isDeleteLoading, onClick: function () { return handleDeleteDialogOpen(params.row); }, children: _jsx(Trash, {}) }) })] })); }
        });
        return __spreadArray(__spreadArray([], __read(baseColumns), false), __read(additionalColumns), false);
    };
    var specialitiesColumns = generateRoleColumns();
    var handleAddDialogOpen = function () {
        setIsAddDialogOpen(true);
    };
    var handleAddDialogClose = function () {
        setIsAddDialogOpen(false);
    };
    var handleEditDialogOpen = function (speciality) {
        setEditingSpeciality(speciality);
        setIsEditDialogOpen(true);
    };
    var handleEditDialogClose = function () {
        setEditingSpeciality(null);
        setIsEditDialogOpen(false);
    };
    var handleDeleteDialogOpen = function (speciality) {
        setDeletingSpecialty(speciality);
        setIsDeleteDialogOpen(true);
    };
    var handleSwitchChange = function (speciality) {
        setConfirmationDialogContent("".concat(tWithFunction('settings.technicianSpecialties.statusConfirmText', speciality.isActive ? 'common.deactivate' : 'common.activate'), " ").concat(speciality.name, "?"));
        setSpecialityStatus({
            id: speciality.id,
            isActive: !speciality.isActive,
            name: speciality.name,
            companyName: speciality.companyName,
            createdDate: speciality.createdDate
        });
        setIsConfirmationDialogOpen(true);
    };
    var handleUpdateStatusConfirmation = function () {
        triggerUpdateStatus(specialityStatus);
        setIsConfirmationDialogOpen(false);
    };
    var handleDeleteConfirmation = function () {
        if (deletingSpecialty)
            triggerDelete(deletingSpecialty.id);
        setIsDeleteDialogOpen(false);
    };
    return (_jsxs(Box, { mt: 1, children: [_jsx(ProtectedElement, { permissions: [Permissions.Settings.Create], children: _jsx(PageHeaderButton, { text: translate('actions.add'), icon: _jsx(Add01Icon, { size: isXs ? 17 : undefined }), size: isXs ? 'small' : 'medium', onClick: handleAddDialogOpen, variant: 'contained', color: 'primary', title: tWithFunction('actions.addFunction', 'common.technicianSpeciality') }) }), isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(TechnicianSpecialtiesCards, { specialities: specialities, isUpdateStatusLoading: isUpdateStatusLoading, isDeleteLoading: isDeleteLoading, onEdit: handleEditDialogOpen, onDelete: handleDeleteDialogOpen, onStatusChange: handleSwitchChange, setSpecialityFilters: setSpecialityFilters, specialityFilters: specialityFilters })) : (_jsx(TechnicianSpecialtiesDatagrid, { specialities: specialities, specialitiesColumns: specialitiesColumns, isFetching: isFetching, paginationModel: {
                    page: specialityFilters.page - 1,
                    pageSize: specialityFilters.pageSize
                }, filterModel: filterModel, handleFilterModelChange: handleFilterModelChange, handleSortModelChange: handleSortModelChange, rowCount: rowCount, handlePaginationModelChange: handlePaginationModelChange, isscreen600900: isscreen600900, isscreen9001200Landscape: iscreen9001200, iscreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape })), _jsx(AddSpecialty, { open: isAddDialogOpen, onClose: handleAddDialogClose }), _jsx(EditSpecialty, { open: isEditDialogOpen, onClose: handleEditDialogClose, speciality: editingSpeciality }), _jsx(ConfirmationDialog, { open: isConfirmationDialogOpen, onClose: function () { return setIsConfirmationDialogOpen(false); }, onConfirm: handleUpdateStatusConfirmation, title: translate('actions.confirmAction'), content: confirmationDialogContent }), _jsx(DeleteSpecialtyDialog, { open: isDeleteDialogOpen, onClose: function () { return setIsDeleteDialogOpen(false); }, onConfirm: handleDeleteConfirmation, title: tWithFunction('actions.deleteFunction', 'common.technicianSpeciality'), content: "".concat(translate('settings.technicianSpecialties.deleteConfirmFunction'), " ").concat(deletingSpecialty === null || deletingSpecialty === void 0 ? void 0 : deletingSpecialty.name, "?") })] }));
};
export default TechnicianSpecialties;
